import { Divider } from 'components/Divider/Divider';
import { Icon } from 'components/Icon/Icon';
import { Tag } from 'components/Tag/Tag';

export function ListingViewExpiredTag() {
  return (
    <div>
      <Tag
        variant="danger"
        size="small"
        prefix={<Icon name="circle-minus" size={12} />}
      >
        {getText('This listing has expired')}
      </Tag>

      <Divider marginTop={20} marginBottom={24} />
    </div>
  );
}
